import { all, call, put, takeEvery } from "redux-saga/effects";
import API from "../../../Utils/api";
import {
  reportInfoSuccess,
  reportInfoFailure,
} from "../../Action";
import { REPORT_INFO } from "../../Action/actionTypes";
import { notifyError } from "../../../Utils/Helper";

function* reportInfoRequest(action) {
  try {
    const { data } = yield API.get(`/transaction-info?token=${action?.payload?.token}`);
    if (data?.meta?.code === 200) {
      yield put(reportInfoSuccess(data?.data));
      if (action?.payload?.callback) {
        yield call(action.payload.callback, data);
      }
    } else {
      yield put(reportInfoFailure());
      notifyError("Invalid Request.");
    }
  } catch (error) {
    yield put(reportInfoFailure());
    notifyError("Invalid Request.");
  }
}

export function* watchReportInfoAPI() {
  yield takeEvery(REPORT_INFO, reportInfoRequest);
}

export default function* rootSaga() {
  yield all([watchReportInfoAPI()]);
}
